import React from "react";

export default function Random() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 64 64"
    >
      <path
        fill="#000"
        fillRule="evenodd"
        d="M29.38 58.66h-2.684v-5.365h5.366v2.683a2.682 2.682 0 0 1-2.683 2.683Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M32.062 53.338h-5.366v-5.366h5.366v5.366ZM32.062 42.692h-5.366v-5.366h2.683a2.683 2.683 0 0 1 2.683 2.683v2.683ZM42.708 63.984h-5.366v-5.366h5.366v5.366Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M48.031 58.706h-5.365V53.34h5.365v5.365ZM37.385 58.66h-2.682a2.683 2.683 0 0 1-2.683-2.682v-2.683h5.365v5.366ZM21.416 55.978a2.683 2.683 0 1 1-5.365 0 2.683 2.683 0 0 1 5.365 0ZM64 58.706h-2.683a2.682 2.682 0 1 1 0-5.366H64v5.365ZM55.994 53.338a2.683 2.683 0 1 1 0-5.366 2.683 2.683 0 0 1 0 5.366Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M50.671 53.338a2.683 2.683 0 0 1-2.683-2.683v-2.683h5.366v2.683a2.683 2.683 0 0 1-2.683 2.683ZM40.025 53.338a2.683 2.683 0 0 1-2.683-2.683v-2.683h5.366v2.683a2.683 2.683 0 0 1-2.683 2.683Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M37.385 53.338H32.02v-5.366h5.365v5.366ZM53.354 48.014h-5.366v-2.682a2.683 2.683 0 0 1 2.683-2.683h2.683v5.365Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M48.031 48.014h-5.365v-2.682a2.683 2.683 0 1 1 5.365 0v2.682Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M42.708 48.014h-5.366v-2.682a2.683 2.683 0 0 1 5.366 0v2.682Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M37.385 48.014H32.02V42.65h5.365v5.365ZM24.056 48.014h-2.683V42.65h2.683a2.683 2.683 0 1 1 0 5.365ZM58.677 42.692h-5.366v-5.366h5.366v5.366Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M37.385 42.692H32.02v-2.683a2.683 2.683 0 0 1 2.682-2.683h2.683v5.366ZM21.416 42.692h-5.365v-5.366h5.365v5.366ZM45.392 37.325a2.683 2.683 0 0 1-2.682-2.683v-2.683h5.365v2.683a2.682 2.682 0 0 1-2.683 2.683Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M21.416 37.369h-5.365v-5.366h5.365v5.366ZM64 32.046h-5.366V26.68H64v5.366ZM53.354 32.046h-5.366V26.68h5.366v5.366ZM37.342 29.364a2.682 2.682 0 0 0 2.683 2.683h2.683V26.68h-2.683a2.683 2.683 0 0 0-2.683 2.683ZM29.38 32.047a2.683 2.683 0 0 1-2.683-2.683V26.68h5.365v2.683a2.683 2.683 0 0 1-2.682 2.683Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M21.416 32.046h-5.365V26.68h5.365v5.366ZM64 26.723h-5.366v-5.366H64v5.366Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M55.994 26.723h-2.683v-5.366h2.683a2.682 2.682 0 1 1 0 5.366ZM48.031 26.723h-5.365v-5.366h5.365v5.366ZM32.062 26.723h-5.366v-5.366h5.366v5.366Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M24.056 26.723a2.683 2.683 0 1 1 0-5.366 2.683 2.683 0 0 1 0 5.366ZM13.379 48.014h-2.683V42.65h2.683a2.683 2.683 0 1 1 0 5.365ZM13.379 26.723a2.683 2.683 0 1 1 0-5.366 2.683 2.683 0 0 1 0 5.366Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M21.416 26.723h-5.365v-5.366h5.365v5.366ZM64 21.4h-5.366v-5.366H64V21.4ZM53.354 21.4H50.67a2.682 2.682 0 1 1 0-5.366h2.683V21.4Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M48.031 21.4h-5.365v-5.366h5.365V21.4ZM5.41 58.706H.046V53.34h5.366v5.365Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M5.41 64H.046v-5.366h5.366V64ZM5.41 48.014H.046v-2.682a2.683 2.683 0 0 1 5.366 0v2.682ZM2.772 37.325a2.683 2.683 0 0 1-2.683-2.683v-2.683h5.366v2.683a2.683 2.683 0 0 1-2.683 2.683ZM5.41 26.723H.046v-5.366h5.366v5.366Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M5.41 21.4H.046v-5.366h5.366V21.4ZM32.02 21.4h2.682a2.682 2.682 0 0 0 2.683-2.683v-2.683h-5.366V21.4ZM10.736 58.66H8.054a2.683 2.683 0 0 1-2.683-2.682v-2.683h5.365v5.366Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M10.736 53.338H5.371v-5.366h5.365v5.366Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M10.736 48.014H5.371V42.65h5.365v5.365Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M10.736 42.692H5.371v-2.683a2.683 2.683 0 0 1 2.683-2.683h2.682v5.366ZM5.37 21.4h2.683a2.682 2.682 0 0 0 2.683-2.683v-2.683H5.371V21.4ZM32.062 21.4h-5.366v-5.366h5.366V21.4ZM21.416 21.4h-5.365v-5.366h5.365V21.4ZM53.354 16.017H50.67a2.683 2.683 0 1 1 0-5.365h2.683v5.365Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M48.031 16.017h-5.365v-5.365h5.365v5.365ZM32.02 10.651h2.682a2.683 2.683 0 0 1 2.683 2.683v2.683h-5.366V10.65ZM5.37 10.651h2.683a2.683 2.683 0 0 1 2.683 2.683v2.683H5.371V10.65ZM21.416 16.017h-5.365v-5.365h5.365v5.365ZM32.062 5.366h-5.366V0h2.683a2.683 2.683 0 0 1 2.683 2.683v2.683Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M53.354 10.688h-5.366V8.006a2.683 2.683 0 0 1 2.683-2.683h2.683v5.365Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M48.031 10.688h-5.365V8.006a2.683 2.683 0 1 1 5.365 0v2.682Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M42.708 10.688h-5.366V8.006a2.683 2.683 0 0 1 5.366 0v2.682Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M37.385 10.688H32.02V5.323h5.365v5.365ZM24.056 10.688h-2.683V5.323h2.683a2.683 2.683 0 0 1 0 5.365ZM58.677 5.366h-5.366V0h5.366v5.366Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M37.385 5.366H32.02V2.683A2.683 2.683 0 0 1 34.702 0h2.683v5.366ZM21.416 5.366h-5.365V0h5.365v5.366ZM13.379 10.688h-2.683V5.323h2.683a2.683 2.683 0 0 1 0 5.365ZM5.41 10.688H.046V8.006a2.683 2.683 0 0 1 5.366 0v2.682Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M10.736 10.688H5.371V5.323h5.365v5.365Z"
        clipRule="evenodd"
      />
      <path
        fill="#000"
        fillRule="evenodd"
        d="M10.736 5.366H5.371V2.683A2.683 2.683 0 0 1 8.054 0h2.682v5.366Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
